'use client'
import { CardText } from '@morpho-org/ui-v6/server'
import { memo } from 'react'

const UtilizationTableError = () => {
  return (
    <div className="gap-sm flex flex-col">
      <CardText width="100%" height="328px" text="An error occurred." />
    </div>
  )
}

export default memo(UtilizationTableError)
